import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumberFormat]'
})
export class NumberFormatDirective {
  private regex: RegExp = new RegExp(/^[0-9]+(\.[0-9]{0,2})?$/g);

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event'])
  onInput(event: KeyboardEvent) {
    const input = this.el.nativeElement;
    const { selectionStart } = input;


    let value = input.value.replace(/[^0-9.]/g, '');


    const parts = value.split('.');
    if (parts.length > 2) {
      parts.splice(2);
      value = parts.join('.');
    }

    if (parts[1] && parts[1].length > 2) {
      parts[1] = parts[1].substring(0, 2);
      value = parts.join('.');
    }

    const formattedValue = this.formatNumber(value);
    input.value = formattedValue;
    const newSelectionStart = selectionStart + (formattedValue.length - value.length);
    input.setSelectionRange(newSelectionStart, newSelectionStart);
  }

  @HostListener('blur', ['$event'])
  onBlur(event: FocusEvent) {
    const input = this.el.nativeElement;
    let value = input.value;

    if (value) {
      const numericValue = parseFloat(value.replace(/,/g, ''));
      input.value = numericValue.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  }

  private formatNumber(value: string): string {
    if (!value) return '';

    const parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return parts.join('.');
  }
}
